export const sanitizeSensitiveParams = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const sensitiveParams = [
      "reset_password_token",
      "welcome_token",
      "auth_token",
      "session_id",
      "api_key",
      "access_token",
      "refresh_token"
    ];

    sensitiveParams.forEach((param) => {
      if (urlObj.searchParams.has(param)) {
        urlObj.searchParams.set(param, "[REDACTED]");
      }
    });

    return urlObj.toString();
  } catch {
    return url;
  }
};
